export default "__VITE_ASSET__LsivERQu__"